import React from 'react';
import styled from 'styled-components';
import Button from '../../../components/Button/Button';
import { AiFillInfoCircle } from 'react-icons/ai';

const AccountStatus: React.FC<Props> = ({
	AvatarUploader,
	isSmallScreen,
	user,
	notify,
	refreshPortalUser,
	onShowVerifyID,
	isVerified,
}) => {
	if (!user) return null;

	return (
		<AccountStatusContainer>
			<AvatarUploader user={user} isSmallScreen={isSmallScreen} refreshUser={refreshPortalUser} notify={notify} />
			<UserInfoSection isSmallScreen={isSmallScreen}>
				{user.first_name && <UserInfoGreeting isSmallScreen={isSmallScreen}>Hi, {user.first_name}</UserInfoGreeting>}
				<UserInfoCommon>@{user.name}</UserInfoCommon>
				<UserInfoCommon>Client Account ID #{user.id}</UserInfoCommon>
				<UserInfoCommon>Telephone PIN #{user.pin}</UserInfoCommon>
			</UserInfoSection>

			<VerifyStatus isSmallScreen={isSmallScreen} isVerified={isVerified} />
			{!user?.id_verified && (
				<VerifyIDButton
					kind="hollow-white"
					isSmallScreen={isSmallScreen}
					disabled={user?.id_verified}
					onClick={onShowVerifyID}
				>
					Verify Now
				</VerifyIDButton>
			)}
		</AccountStatusContainer>
	);
};
const VerifyStatus = ({ isVerified, isSmallScreen }: { isVerified: boolean; isSmallScreen: boolean }) => {
	const [showToolTip, setShowToolTip] = React.useState(false);
	const onToggle = React.useCallback(() => setShowToolTip(!showToolTip), [showToolTip]);
	return (
		<VerifyStatusContainer isSmallScreen={isSmallScreen}>
			<VerifyBadge $isVerified={isVerified}>{isVerified ? 'Verified' : 'Unverified'}</VerifyBadge>
			{!isVerified && (
				<div
					style={{
						position: 'relative',
						display: 'inline',
					}}
				>
					<AiFillInfoCircle color="#707070" onClick={onToggle} cursor={'pointer'} width={17} height={17} />
					{showToolTip && (
						<ToolTip isSmallScreen={isSmallScreen}>
							New users are required to verify their identity. If verification is not completed, your account will be
							locked and no further wagering activity can take place until successful verification.
						</ToolTip>
					)}
					{showToolTip && <Arrow isSmallScreen={isSmallScreen} />}
				</div>
			)}
		</VerifyStatusContainer>
	);
};
export default AccountStatus;

interface Props {
	isSmallScreen: boolean;
	notify: (options: any) => void;
	refreshPortalUser: () => void;
	onShowVerifyID: () => void;
	user: PortalUser;
	AvatarUploader: React.FC<{
		user: PortalUser;
		isSmallScreen: boolean;
		refreshUser: () => void;
		notify: (options: any) => void;
	}>;
	isVerified: boolean;
}

const VerifyBadge = styled.div<{ $isVerified: boolean }>(({ $isVerified }) => ({
	color: '#fff',
	fontWeight: 600,
	marginRight: 3,
	backgroundColor: $isVerified ? '#18B531' : '#CD3024',
	paddingLeft: 10,
	paddingRight: 10,
	borderRadius: 20,
	paddingTop: '4px',
	paddingBottom: '4px',
}));

const Arrow = styled.div<{ isSmallScreen: boolean }>({
	position: 'absolute',
	display: 'flex',
	bottom: '105%',
	left: '50%',
	width: 0,
	height: 0,
	borderLeft: '10px solid transparent',
	borderRight: '10px solid transparent',
	borderTop: '10px solid white',
	transform: 'translateX(-50%)',
});
const AccountStatusContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
const ToolTip = styled.div<{ isSmallScreen: boolean }>(({ isSmallScreen }) => ({
	position: 'absolute',
	bottom: '150%',
	left: -180,
	backgroundColor: '#fff',
	width: 315,
	borderRadius: 8,
	padding: 9,
	color: '#191D22',
	fontSize: 11,
}));
const VerifyStatusContainer = styled.div<{ isSmallScreen: boolean }>({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'row',
});
const UserInfoSection = styled.div<{ isSmallScreen: boolean }>`
	text-align: center;
	color: ${({ theme }) => theme.colors.greyR};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '16px')};
`;

const UserInfoGreeting = styled.p<{ isSmallScreen: boolean }>`
	color: ${({ theme }) => theme.colors.white};
	font-weight: 600;
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '22px' : '26px')};
	margin-bottom: 15px;
`;

const UserInfoCommon = styled.p`
	margin-bottom: 5px;
	line-height: 20px;
`;

const VerifyIDButton = styled(Button)<{ isSmallScreen: boolean }>`
	width: 90%;
	margin-top: ${({ isSmallScreen }) => (isSmallScreen ? '20px' : '30px')};
	background-color: ${({ theme }) => theme.colors.white};
	color: #151a21;
`;
